import React, { Component } from "react";
import "./SkillCards.scss";

import SkillCard from "./SkillCard";

import imgReact from "../../../../assets/images/react.svg";
import imgAndroid from "../../../../assets/images/android.svg";
import imgFlutter from "../../../../assets/images/flutter.svg";
import imgDjango from "../../../../assets/images/django.png";
import imgAngular from "../../../../assets/images/angular.svg";

class SkillCards extends Component {
	constructor() {
		super();
		this.cardsValues = [
			{
				src: imgAngular,
				value: "Angular",
				url: "https://angular.io",
			},
			{
				src: imgReact,
				value: "React",
				url: "https://reactjs.org",
			},
			{
				src: imgDjango,
				value: "Django",
				url: "https://www.djangoproject.com",
			},
			{
				src: imgAndroid,
				value: "Android",
				url: "https://developer.android.com",
			},
			{
				src: imgFlutter,
				value: "Flutter",
				url: "https://flutter.dev",
			},
		];
	}
	render() {
		return (
			<div className="skillCards">
				{this.cardsValues.map((e, i) => {
					return <SkillCard key={i} src={e.src} value={e.value} url={e.url} />;
				})}
			</div>
		);
	}
}

export default SkillCards;
